export default {
  diffusionInputs: 'Diffusionseingaben',
};
